export const activityGridEntries = [
  {
    key: 'vipClub',
    route: '/vipLevels',
    requiresLogin: true
  },
  {
    key: 'inviteBonus',
    route: '/Alliance',
    requiresLogin: true
  },
  {
    key: 'missions',
    route: '/weeklyMissions',
    requiresLogin: true
  },
  {
    key: 'rebate',
    route: '/luckyReferral',
    requiresLogin: true
  }
]

export const gameActivityEntries = [
  {
    key: 'luckyWheel',
    route: '/luckyReferral',
    requiresLogin: true
  },
  {
    key: 'luckyDraw',
    route: '/activityFistRecharge',
    requiresLogin: true
  }
]

export const menuUtilityEntries = [
  {
    key: 'privacy',
    route: '/privacy',
    requiresLogin: false
  },
  {
    key: 'support',
    route: '/Support',
    requiresLogin: false
  },
  {
    key: 'redPacket',
    route: '/redPacket',
    requiresLogin: true
  },
  {
    key: 'partner',
    route: '/Alliance',
    requiresLogin: true
  }
]

export const topNavUtilityEntries = [
  {
    key: 'collection',
    route: '/myCollection',
    requiresLogin: true
  },
  ...menuUtilityEntries
]

export function entryAt(entries, index) {
  const visibleEntries = Array.isArray(entries)
    ? entries.filter((entry) => entry && entry.enabled !== false)
    : []
  return visibleEntries[index] || null
}
